import {buildUrl} from "../service/url-builder";
const axios = require('axios');

function generatePerformanceIndicator(indicatorConfig, year){
    return axios.post(buildUrl("/generate/indicatorPerformance"), {
        indicatorConfigName: indicatorConfig,
        year:year
    }).then(response => {
        return response.data;
    });
}

function generateBacktest(configName, year){
    return axios.post(buildUrl("/generate/backtest"), {
        configName: configName,
        year:year
    }).then(response => {
        return response.data;
    });
}


function generateSummary(params){
    return axios.post(buildUrl("/generate/summary"), params).then(response => {
        return response.data;
    });
}

export {generatePerformanceIndicator, generateBacktest, generateSummary}